<template>
  <div>
    <form @submit.prevent="onSubmit" v-if="!complete">
      <h2 class="font-primary font-extrabold text-28 md:text-32 leading-1 -tracking-1/2 mb-4 text-blue-brand">{{ selectedAdventure.name }}</h2>

      <login-form v-if="!user"></login-form>

      <p class="mt-2 mb-6" v-if="!user">
        If this is your first booking with us, please fill in your details below and a YellowWood
        account will be created for you as part of your booking.
      </p>

      <template v-if="user">
        <div class="label block mb-2">
          Your Name
        </div>
        <div class="mb-4 text-xl">
          {{ real_name }}
        </div>
        <p class="my-6">
          We require at least one method to contact you back. If you provide both you can select
          which is your preferred.
        </p>

        <div class="flex my-8">
          <div class="w-2/3 md:w-1/2 mr-3">
            <label for="enquiryPhone" class="label block mb-2">Contact Number</label>
            <input
              type="tel"
              name="enquiryPhone"
              class="input block w-full"
              placeholder="Phone Number..."
              v-model="phone"
            />
            <!-- <phone-mask-input
              ref="phoneNumber"
              v-model="phone"
              autoDetectCountry
              inputClass="input block w-full"
              defaultCountry="UK"
              @onValidate="onUpdatePhoneNumber"
            ></phone-mask-input>
            <error-message :errors="getErrors('phone')"></error-message> -->
          </div>
          <div class="ml-3">
            <div v-if="hasEmailAndPhone">
              <span class="font-extrabold block mb-2">Preferred</span>
              <div class="relative inline-block mt-2">
                <input
                  type="radio"
                  name="preferredContact"
                  value="phone"
                  v-model="preferredContact"
                  class="h-5 w-5 rounded cursor-pointer align-middle"
                />
                <span class="radio-dot"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex my-4">
          <div class="w-2/3 md:w-1/2 mr-3">
            <label for="bookingEmailExisting" class="label block mb-2">Contact Email</label>
            <input
              type="email"
              name="bookingEmailExisting"
              class="input block w-full"
              placeholder="Email address..."
              v-model="email"
            />
          </div>
          <div class="ml-3 mt-9">
            <div v-if="hasEmailAndPhone" class="relative inline-block">
              <input
                type="radio"
                name="preferredContact"
                value="email"
                v-model="preferredContact"
                class="h-5 w-5 rounded cursor-pointer align-middle"
              />
              <span class="radio-dot"></span>
            </div>
          </div>
        </div>

        <error-message :errors="getErrors('email')"></error-message>
      </template>
      <template v-else>
        <div class="flex flex-col md:flex-row mb-4">
          <div class="w-full md:w-1/2 md:mr-2.5 mb-4">
            <label for="bookingName" class="label block mb-2">Your Name *</label>
            <input
              type="text"
              name="bookingName"
              class="input block w-full"
              placeholder="Full name..."
              v-model="real_name"
            />
            <error-message :errors="getErrors('name')"></error-message>
          </div>
          <div class="w-full md:w-1/2 md:ml-2.5">
            <label for="bookingEmail" class="label block mb-2">Email</label>
            <input
              type="text"
              name="bookingEmail"
              class="input block w-full"
              placeholder="Email address..."
              v-model="email"
            />
            <error-message :errors="getErrors('email')"></error-message>
          </div>
        </div>

        <div class="flex flex-col md:flex-row mb-4">
          <div class="w-full md:w-1/2 md:mr-2.5 mb-4">
            <label for="bookingPassword" class="label block mb-2">Password</label>
            <input
              type="password"
              name="bookingPassword"
              class="input block w-full"
              placeholder="Create password..."
              v-model="password"
            />
          </div>
          <div class="w-full md:w-1/2 md:ml-2.5">
            <label for="bookingPasswordConfirmation" class="label block mb-2"
              >Re-type Password</label
            >
            <input
              type="password"
              name="bookingPasswordConfirmation"
              class="input block w-full"
              placeholder="Password again..."
              v-model="passwordConfirmation"
            />
          </div>
        </div>

        <error-message :errors="getErrors('password')"></error-message>

        <div class="flex mb-4">
          <div class="w-full md:w-1/2 md:mr-2.5">
            <label for="bookingPhone" class="label block mb-2">Phone</label>
            <!-- <phone-mask-input
              ref="phoneNumber"
              v-model="phone"
              autoDetectCountry
              inputClass="input block w-full"
              defaultCountry="UK"
              @onValidate="onUpdatePhoneNumber"
            ></phone-mask-input> -->
            <input
              type="tel"
              name="bookingPhone"
              class="input block w-full"
              placeholder="Phone Number..."
              v-model="phone"
            />
          </div>
        </div>
      </template>

      <div class="mt-8 mb-4">
        <label for="enquiryNotes" class="label block mb-2">Additional notes</label>
        <textarea
          name="enquiryNotes"
          class="input w-full"
          rows="4"
          placeholder="Any additional requirements or queries..."
          v-model="notes"
        ></textarea>
      </div>

      <error-message :errors="getErrors('notes')"></error-message>

      <div v-if="selectedDeparture">
        <departure-selection :force-show-dropdowns="true"></departure-selection>

        <h3 class="font-extrabold font-primary text-sm my-4">Price</h3>
        <div class="flex my-4">
          <div class="flex-auto w-1/2 text-center">
            <p class="font-extrabold text-sm font-primary">
              Deposit
              <button type="button" @click.prevent="showDepositTooltip = !showDepositTooltip">
                <svg-sprite
                  href="icon-tooltip"
                  class="h-4 w-4 ml-1 inline-block cursor-pointer"
                ></svg-sprite>
              </button>
              <generic-tooltip v-if="showDepositTooltip" @close="showDepositTooltip = false">
                <h3 class="font-extrabold text-2xl font-primary text-blue-brand">
                  Deposit
                </h3>
                <dynamic-copy
                  slug="deposit-description"
                  type="html"
                  class="my-4 text-lg text-blue-dark leading-relaxed"
                >
                  Loading...
                </dynamic-copy>
                <button type="button" class="button" @click.prevent="showDepositTooltip = false">
                  Close
                </button>
              </generic-tooltip>
            </p>
            <p class="text-3xl font-extrabold font-primary">
              <display-price
                :price-gbp="finalDepositAmountGBP"
                :price-usd="finalDepositAmountUSD"
              ></display-price>
            </p>
          </div>
          <div class="flex-auto w-1/2 text-center">
            <p class="font-extrabold text-sm font-primary">Total Payable</p>
            <p class="text-3xl font-extrabold font-primary">
              <display-price :price-gbp="priceGbp" :price-usd="priceUsd"></display-price>
            </p>
          </div>
        </div>
      </div>








      <div class="mt-8 mb-4">
        <div class="label block mb-2">What brought you to our website today?</div>
        <div class="grid grid-cols-2 gap-4">

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Search'), 'bg-white': !source.includes('Search')}" class="w-4 h-4 text-blue-600 border-gray-300 rounded flex-shrink-0 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Search" />
            <span class="text-gray-700">Search</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Social media'), 'bg-white': !source.includes('Social media')}" class="w-4 h-4 text-blue-600 border-gray-300 flex-shrink-0 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Social media" />
            <span class="text-gray-700">Social media</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('LinkedIn'), 'bg-white': !source.includes('LinkedIn')}" class="w-4 h-4 text-blue-600 border-gray-300 rounded flex-shrink-0 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="LinkedIn" />
            <span class="text-gray-700">LinkedIn</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('YellowWood Newsletter'), 'bg-white': !source.includes('YellowWood Newsletter')}" class="w-4 h-4 text-blue-600 flex-shrink-0 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="YellowWood Newsletter" />
            <span class="text-gray-700">YellowWood Newsletter</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Referral from another website'), 'bg-white': !source.includes('Referral from another website')}" class="w-4 h-4 flex-shrink-0 text-blue-600 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Referral from another website" />
            <span class="text-gray-700">Referral from another website</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Personal recommendation'), 'bg-white': !source.includes('Personal recommendation')}" class="w-4 h-4 text-blue-600 flex-shrink-0 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Personal recommendation" />
            <span class="text-gray-700">Personal recommendation</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Knew YWA already'), 'bg-white': !source.includes('Knew YWA already')}" class="w-4 h-4 text-blue-600 border-gray-300 flex-shrink-0 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Knew YWA already" />
            <span class="text-gray-700">Knew YWA already</span>
          </label>

          <label class="flex items-center space-x-3">
            <input type="checkbox" :class="{'bg-blue-500': source.includes('Other'), 'bg-white': !source.includes('Other')}" class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 flex-shrink-0 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" v-model="source" name="source[]" value="Other" />
            <span class="text-gray-700">Other</span>
          </label>

        </div>
      </div>





      <div class="my-4">
        <label class="block mt-2">
          <div class="relative inline-block mr-2">
            <input
              class="h-5 w-5 bg-white rounded checked:bg-yellow-brand cursor-pointer align-middle"
              type="checkbox"
              v-model="agreeToTerms"
            />
            <svg-sprite href="icon-tick" class="checkbox-tick h-4 w-4 absolute pin-c"></svg-sprite>
          </div>
          <span class="text-xs align-middle">
            Agree to
            <a :href="termsUrl" target="_blank" rel="noopener noreferrer" class="underline"
              >terms &amp; conditions</a
            >. You can read our
            <a :href="faqUrl" target="_blank" rel="noopener noreferrer" class="underline"
              >FAQs here</a
            >.
          </span>
        </label>
      </div>

      <div v-if="errorMessage" class="text-red-400 my-4">
        {{ errorMessage }}
      </div>

      <button type="submit" class="button makebookingbtn min-w-280 md:min-w-360" :disabled="!canBeSubmitted || submitting">
        {{ submitting ? 'Please wait...' : 'Make Booking' }}
      </button>
    </form>
    <div v-else>
      <h2 class="text-4xl font-extrabold">Done!</h2>
      <p>
        One moment while we redirect you...
      </p>
    </div>
    <invisible-payment-form :details="paymentFormDetails"></invisible-payment-form>
  </div>
</template>

<script>
import DepartureSelection from './DepartureSelection.vue';
import DisplayPrice from './DisplayPrice.vue';
import DynamicCopy from './DynamicCopy.vue';
import ErrorMessage from './ErrorMessage.vue';
import get from 'lodash/get';
import GenericTooltip from './GenericTooltip.vue';
import InvisiblePaymentForm from './InvisiblePaymentForm.vue';
import HandlesAdventures from './Mixins/HandlesAdventures';
import HandlesErrors from './Mixins/HandlesErrors';
import LoginForm from './LoginForm.vue';
import { mapGetters } from 'vuex';
import PhoneMaskInput from  "vue-phone-mask-input";
import Route from '../src/Route';
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';

export default {
  components: {
    DepartureSelection,
    DisplayPrice,
    DynamicCopy,
    ErrorMessage,
    GenericTooltip,
    InvisiblePaymentForm,
    LoginForm,
    PhoneMaskInput,
    SvgSprite,
  },

  mixins: [HandlesErrors, HandlesAdventures],

  props: {
    allowNewsletterSignup: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      real_name: '',
      phone: '',
      email: '',
      preferredContact: 'phone',
      password: '',
      passwordConfirmation: '',
      notes: '',
      source: [],
      newsletter: false,
      submitting: false,
      complete: false,
      showDepositTooltip: false,
      agreeToTerms: false,
      termsUrl: Route('terms-and-conditions'),
      faqUrl: Route('faq'),
      paymentFormDetails: null,
    };
  },

  computed: {
    ...mapGetters('departure', ['priceGbp', 'priceUsd']),

    user() {
      return this.$store.state.user.user;
    },

    canBeSubmitted() {
      if (!this.agreeToTerms) {
        return false;
      }

      if (this.peopleCount < 1) {
        return false;
      }

      if (this.user) {
        if (!this.phone && !this.email) {
          return false;
        }

        return true;
      }

      if (!this.real_name) {
        return false;
      }

      if (!this.phone && !this.email) {
        return false;
      }

      if (!this.password) {
        return false;
      }

      if (!this.passwordConfirmation) {
        return false;
      }

      return true;
    },

    hasEmailAndPhone() {
      return !!this.email && !!this.phone;
    },

    finalDepositAmountGBP() {
      return this.selectedDeparture.deposit_amount_gbp * this.peopleCount;
    },

    finalDepositAmountUSD() {
      return this.selectedDeparture.deposit_amount_usd * this.peopleCount;
    },
  },

  methods: {
    onUpdatePhoneNumber(payload) {
      if (payload.isValidByLibPhoneNumberJs) {
        this.phone = payload.number;
      }
    },

    onSubmit() {
      this.submitting = true;
      this.resetErrors();

      const data = {
        name: this.real_name,
        phone: this.phone,
        email: this.email,
        people: this.peopleCount,
        newsletter: this.newsletter,
        notes: this.notes,
        source: this.source.join(', '),
        preferred_contact: this.preferredContact,
      };

      if (this.selectedDeparture) {
        Object.assign(data, this.compileAddonsAndExtrasForXHR());
      }

      if (!this.user) {
        data.password = this.password;
        data.password_confirmation = this.passwordConfirmation;
        data.name = this.real_name;
      }

      axios
        .post(Route('json.bookings.store'), data, { withCredentials: true })
        .then((response) => {
          if (response.status !== 200) {
            throw 'Network error.';
          }

          this.paymentFormDetails = get(response, 'data.worldpay_details');
          this.complete = true;
        })
        .catch(this.handleXHRErrors)
        .then(() => {
          this.submitting = false;
        });
    },

    useExistingUserDetails() {
      this.real_name = this.user.real_name;
      this.email = this.user.email;
      this.phone = this.user.phone;
    },
  },

  created() {
    if (this.user) {
      this.useExistingUserDetails();
    }
  },

  watch: {
    user() {
      this.useExistingUserDetails();
    },
  },
};
</script>
